module.exports = __webpack_public_path__ + "img/screenshot-step4-student.8c2f10ab.png";